<template>
  <transition :name="transitionName">
    <div v-show="!disabled && (visible || always)" :class="classes">
      <div :class="[prefixCls + '-content']">
        <div :class="[prefixCls + '-arrow']" :style="popperStyle"></div>
        <div :class="[prefixCls + '-inner']" :style="{backgroundColor: color}">
          <slot><div :class="{'text-truncate': ellipsis}">{{ content }}</div></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Popper from 'popper.js'
export default {
  name: 'TTooltip',
  props: {
    transitionName: {
      type: String,
      default: 'fade'
    },
    placement: {
      type: String,
      default: 'top',
      validator: (value) => {
        /* [
          'top',
          'top-start',
          'top-end',
          'bottom',
          'bottom-start',
          'bottom-end',
          'left',
          'left-start',
          'left-end',
          'right',
          'right-start',
          'right-end'
        ] */
        return Popper.placements.includes(value)
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    always: {
      type: Boolean,
      default: false
    },
    content: {
      type: [ String, Number ],
      default: ''
    },
    ellipsis: {
      type: Boolean,
      default: false
    },
    prefixCls: {
      type: String,
      default: 'tooltip'
    },
    color: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    classes () {
      return [ this.prefixCls ]
    },
    popperStyle() {
      return {
        'borderRightColor': this.placement.indexOf('right') > -1 ? this.color : '',
        'borderLeftColor': this.placement.indexOf('left') > -1 ? this.color : '',
        'borderTopColor': this.placement.indexOf('top') > -1 ? this.color : '',
        'borderBottomColor': this.placement.indexOf('bottom') > -1 ? this.color : ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/tooltip/tooltip.vue